import React from "react";
import classnames from "classnames";
import { DatePicker } from "modules/common/components/form/DatePicker";

type DatePickerProps = React.ComponentProps<typeof DatePicker>;

/**
 * Поле даты в стиле planr: `DatePicker` с классом темы `planr-default-input`,
 * который до сих пор передавали вручную (в 47 местах из 51).
 * Заодно у пропа нормальное имя `className` — у `DatePicker` он исторически
 * называется `clasName`.
 *
 * Значение — `Date | null`, формат ввода `дд.мм.гггг`. Время суток хранится
 * только с `timePrecision` (подробности — в `form/DatePicker.tsx`).
 */
export const PlanrDatePicker = ({ className, ...props }: PlanrDatePickerProps) => (
    <DatePicker {...props} clasName={classnames("planr-default-input", className)} />
);

export interface PlanrDatePickerProps extends Omit<DatePickerProps, "clasName"> {
    className?: string;
}
